module.exports = __webpack_public_path__ + "47284cd4962cc5a65d699c8777c0b150.png";